import { CloudUploadOutlined } from "@ant-design/icons";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import "./upload.css";
const CostumeUpload = () => {
  const [image, setImage] = useState<string>();
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    if (e.target.files) {
      setImage(URL.createObjectURL(e.target.files[0]));
    }
  };
  const handleHover = () => { };
  const [t] = useTranslation("common");
  return (
    <>
      <label className="costume-upload" onMouseOver={handleHover}>
        {!image && (
          <div className="icon">
            <CloudUploadOutlined style={{ fontSize: "34px" }} />
            {t("upload-image")}
          </div>
        )}
        <input
          type="file"
          onChange={handleChange}
          style={{ display: "none" }}
        />
        {image && (
          <>
            <img src={image} alt="uploaded-costume" />
          </>
        )}
      </label>
    </>
  );
};

export default CostumeUpload;
